<div
  class="dialog-draggable-header"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
  [cdkDragConstrainPosition]="computeDragRenderPos.bind(this)"
>
  <mat-icon>drag_indicator</mat-icon>
</div>
<div class="dialog-header">
  <span mat-dialog-title>
    {{ 'label_release_update_releasenotes' | translate }}
  </span>
</div>
<div mat-dialog-content class="dialog-with-bottom-buttons releasenotes-content">
  <div class="releasenote-table entity-table">
    <div class="table-wrapper">
      <div class="table-container">
        <div class="release-notes-months-wrapper">
          @for (monthData of dataSourceTable?.data; track trackMonth($index, monthData)) {
            <section class="release-notes-month-section">
              <div class="release-notes-month-header">
                <h3 class="release-notes-month-title">{{ getMonthLabel(monthData) }}</h3>
                <span class="release-notes-month-divider"></span>
              </div>

              <div class="release-notes-grid">
                @for (releaseNote of monthData.releasenotes; track trackReleaseNote($index, releaseNote)) {
                  <div class="release-notes-grid-item">
                    <app-release-note-panel [releaseNote]="releaseNote"></app-release-note-panel>
                  </div>
                }
              </div>
            </section>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="particulars-form no-background dialog-bottom-buttons">
    <div class="particulars-row no-label">
      <div class="particulars-col"></div>
      <div class="particulars-col"></div>
      <div class="particulars-col float-right">
        <span class="control-value button float-right">
          <button [mat-dialog-close]="null" mat-flat-button color="primary">
            {{ 'label_close' | translate }}
          </button>
        </span>
      </div>
    </div>
  </div>
</div>
